export {
  prefix,
  className,
  decodeBase64,
  encodeBase64,
  getNodeTypeFromBase64Id,
  getDateOfBirthFromSouthAfricanID,
  checkValidNumber,
  isValidMSISDN,
  readablePhoneNumber,
  normalizePhoneNumber,
  showAsCurrency,
  roundToDecimals,
  formatCurrency,
  isValidSouthAfricanID,
  isValidPassportNumber,
  isBase64,
  upperCaseFirstCharacter,
  getContentTypeFromNodeType
} from './string'

export { getSprite } from './icon/sprite'

export {
  hasResponsibility,
  hasAnyResponsibility,
  hasAllResponsibilities,
  getIdentityResponsibility,
  getIdentityResponsibilities,
  hasAllIdentityResponsibilities
} from './user'

export { isEmptyObject, removeBlankAttributesFromObject } from './object'
export { asyncLoop } from './loop'

export {
  getDateUTC,
  sortDates,
  hasDateChanged,
  datesInRangeFrequency,
  getNextBusinessDay
} from './date'

export {
  viewableFileFormats,
  fileTypesWithIcons,
  isExcelFile,
  isWordFile,
  getSldsIconType,
  isViewableFileFormat,
  getFileExtension
} from './file'

export {
  chunkArray,
  flattenArray,
  getTotal,
  getUniqueValuesInArrayOfArrays,
  getUniqueValuesInArrayOfObjectsByProperty,
  createArrayWithSequence,
  getArrayDuplicates
} from './array'

export { getAvatarInitialsColour } from './avatar'
export { fireEvent } from './event'

export {
  applyRenderTemplate,
  formatMetricValueByFieldType
} from './metrics'

export {
  isNumeric,
  isPositiveNumeric,
  isNegativeNumeric,
  isNumberInput,
  isPositiveNumberInput,
  isNegativeNumberInput,
  getNodeUrl,
  getNodeTypeFromContentTypeModel,
  getObjectWithArrayValuesAsArraysOfObjects,
  getHealthLevelName
} from './misc'

export {
  runQuery,
  runQueryWithVariables
} from './query'

export {
  getColourConstant
} from './colour'

export {
  PageNavigationControl,
  saveCursor,
  getPageCursor
} from './pagination'

export {
  sortTable
} from './table'



// WEBPACK FOOTER //
// ./src/utils/index.js